module.exports = __webpack_public_path__ + "img/06-03_Acting Diplomatically.d42afea9.svg";